/**
 * Present when the switch is checked.
 */
export const checked = 'data-checked';
/**
 * Present when the switch is not checked.
 */
export const unchecked = 'data-unchecked';
/**
 * Present when the switch is disabled.
 */
export const disabled = 'data-disabled';
/**
 * Present when the switch is readonly.
 */
export const readonly = 'data-readonly';
/**
 * Present when the switch is required.
 */
export const required = 'data-required';
/**
 * Present when the switch is in a valid state (when wrapped in Field.Root).
 */
export const valid = 'data-valid';
/**
 * Present when the switch is in an invalid state (when wrapped in Field.Root).
 */
export const invalid = 'data-invalid';
/**
 * Present when the switch has been touched (when wrapped in Field.Root).
 */
export const touched = 'data-touched';
/**
 * Present when the switch's value has changed (when wrapped in Field.Root).
 */
export const dirty = 'data-dirty';
/**
 * Present when the switch is active (when wrapped in Field.Root).
 */
export const filled = 'data-filled';
/**
 * Present when the switch is focused (when wrapped in Field.Root).
 */
export const focused = 'data-focused';